class SessionController {

	data = null;

	keys = {
		userEmail: 'user_email',
		sessionToken: 'session_token',
		stateToken: 'state_token'
	};

	login(form) {
		return new Promise((resolve, reject) => {
			fetch('/api/login', {
					method: 'POST',
					body: JSON.stringify({
						email: form.get('email'),
						password: form.get('password')
					})
				})
				.then(response => response.json())
				.then((result) => {
					if (result.status.code === 200) {
						this.data = result.data;
						localStorage.setItem(this.keys.userEmail, this.data.user.email);
						sessionStorage.setItem(this.keys.userId, this.data.user.id);
						if (this.data.session_token) sessionStorage.setItem(this.keys.sessionToken, this.data.session_token);
						if (this.data.state_token) sessionStorage.setItem(this.keys.stateToken, this.data.state_token);
						resolve(this.data);
					} else {
						reject();
					}
				})
				.catch(reject);
		});
	}

	verify(form) {
		return new Promise((resolve, reject) => {
			fetch('/api/login/verify', {
					method: 'POST',
					body: JSON.stringify({
						state_token: form.get('state_token'),
						device_id: form.get('device_id'),
						otp_token: form.get('otp_token')
					})
				})
				.then(response => response.json())
				.then((result) => {
					if (result.status.code === 200) {
						this.data = result.data;
						sessionStorage.setItem(this.keys.sessionToken, this.data.session_token);
						sessionStorage.removeItem(this.keys.stateToken);
						resolve(this.data);
					} else {
						reject();
					}
				})
				.catch(reject);
		});
	}

	logout() {
		return new Promise((resolve, reject) => {
			fetch('/api/logout', {
					method: 'POST',
					headers: {
						'Session-Token': sessionStorage.getItem(this.keys.sessionToken)
					}
				})
				.then(response => response.json())
				.then((result) => {
					sessionStorage.removeItem(this.keys.userId);
					sessionStorage.removeItem(this.keys.sessionToken);
					this.data = null;
					result.status.code === 200 ? resolve() : reject();
				})
				.catch(reject);
		});
	}

	checkSession() {
		return new Promise((resolve, reject) => {
			const sessionToken = sessionStorage.getItem(this.keys.sessionToken);
			if (sessionToken) {
				fetch('/api/session', {
						method: 'GET',
						headers: {
							'Session-Token': sessionToken
						}
					})
					.then(response => response.json())
					.then((result) => {
						const { status, data } = result;
						if (status.code === 200) {
							this.data = data;
							resolve(this.data);
						} else {
							reject();
						}
					})
					.catch(reject);
			} else {
				reject();
			}
		});
	}

}

export default new SessionController();
